import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { BaseGridComponent } from 'src/app/shared/components/base-grid/base-grid.component';
import { GridCenterService } from 'src/app/shared/services/grid-center.service';
import { GRID_CONFIG } from 'src/app/shared/services/grid-center.token';
import { DocumentService } from '../../service/document.service';
import { SearchSharedClaimDocumentLinkCriteria } from '../../models/SearchSharedClaimDocumentLinkCriteria';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { SharedClaimDocumentLinkManageComponent } from '../shared-claim-document-link-manage/shared-claim-document-link-manage.component';
import { SharedClaimDocumentLink, SharedClaimDocumentLinkFormBuilder } from '../../models/SharedClaimDocumentLink';

@Component({
  selector: 'app-search-shared-claim-document-links',
  templateUrl: './search-shared-claim-document-links.component.html',
  styleUrls: ['./search-shared-claim-document-links.component.scss'],
  providers: [
    {
      provide: GRID_CONFIG,
      useValue: {
        gridName: 'sharedClaimDocumentLinks',
        initialData: {
          text: '',
          pageNumber: 1,
          rowsPerPage: 10,
          sortDirection: '',
          sortColumn: ''
        }
      }
    },
    GridCenterService
  ]
})
export class SearchSharedClaimDocumentLinksComponent extends BaseGridComponent implements OnInit {

  searchForm!: UntypedFormGroup;
  loading = false;
  view!: Observable<GridDataResult>;

  constructor(
    private fb: UntypedFormBuilder,
    private documentService: DocumentService,
    private customDialogService: CustomDialogService,
    protected gridCenterService: GridCenterService
  ) {
    super(gridCenterService, 'linkHash');
  }

  ngOnInit(): void {
    this.gridCenterService.searchCriteria$
      .pipe(first())
      .subscribe(criteria => {
        this.searchForm = this.fb.group({
          text: [criteria.text]
        });
      });

    this.searchClick();
  }

  @ViewChild('sharedClaimDocumentLinkDialog', { read: ViewContainerRef })
  sharedClaimDocumentLinkDialog!: ViewContainerRef;

  addNewLink(): void {
    const dialogSettings: CustomDialogSettings = {
      content: SharedClaimDocumentLinkManageComponent,
      appendTo: this.sharedClaimDocumentLinkDialog,
      minWidth: '25vw',
      dialogInputs: {
        sharedClaimDocumentLink: SharedClaimDocumentLinkFormBuilder.initSharedClaimDocumentLink()
      },
      resultCallback: (result: DialogResult) => {
        if ((result as { text?: string }).text === 'OK') {
          this.searchAndResetPagesClick();
          this.showLink(result['newAddedId']);

        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  showLink(id:number): void {
    this.documentService.getSharedClaimDocumentLink(id).subscribe(sharedClaimDocumentLink => {
      this.customDialogService.showDialog({
        content: SharedClaimDocumentLinkManageComponent,
        appendTo: this.sharedClaimDocumentLinkDialog,
        minWidth: '35vw',
        dialogInputs: {
          sharedClaimDocumentLink
        }
      });
    });
  }

  isExpired(expirationDate: Date | string): boolean {
    return new Date(expirationDate).getTime() < Date.now();
  }

  searchClick(): void {
    this.loading = true;
    this.setFilters<SearchSharedClaimDocumentLinkCriteria>(this.searchForm.value);
    this.view = this.gridCenterService.searchCriteria$.pipe(
      first(),
      switchMap(criteria => this.documentService.searchSharedClaimDocumentLinks(criteria)),
      map(result => <GridDataResult>{
        data: result,
        total: result?.length > 0 ? result[0].totalCount : 0
      }),
      tap(() => this.loading = false)
    );
  }


}
